import QueryString from "qs"

import { ErrorHandling } from "@/lib/error_handling"
import type { Geolocation } from "@/lib/geolocation"

import { transformLocationIQAddressToBingFormat } from "./transform_response"
import type { LocationIQ } from "./types"

export const fetchReverseGeocodeFromLocationIQ = async ({
  lat,
  lon,
}: {
  lat: number
  lon: number
}): Promise<Geolocation.Bing.Address | null> => {
  const params = QueryString.stringify({
    key: process.env.NEXT_PUBLIC_LOCATIONIQ_API_KEY,
    lat,
    lon,
    format: `json`,
    normalizecity: 1,
  })

  const completion = await ErrorHandling.withRetries({
    process: async () => {
      const response = await fetch(
        `https://api.locationiq.com/v1/reverse?${params}`
      )

      if (!response.ok) {
        throw new Error(`LocationIQ API error: ${response.status}`)
      }

      return response.json() as Promise<LocationIQ.ReverseGeocodeResponse>
    },
    onFatalError: () => {},
    processName: `fetchReverseGeocodeFromLocationIQ`,
  })

  if (!completion.result) {
    console.error(
      `fetchReverseGeocodeFromLocationIQ failed but did not use provided fallback result.`,
      completion
    )
    return null
  }

  return transformLocationIQAddressToBingFormat(completion.result)
}
